var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7,5) scale(0.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 14,
    height: 17,
    rx: 2,
    fill: "none",
    stroke: "#100F15",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5 V3.5 a1 1 0 0 1 1-1 h4 a1 1 0 0 1 1 1 V5",
    fill: "none",
    stroke: "#100F15",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 15,
    y2: 10,
    stroke: "#100F15",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 15,
    y2: 13,
    stroke: "#100F15",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 12,
    y2: 16,
    stroke: "#100F15",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17 v5 m-2.5-2.5 l2.5 2.5 l2.5-2.5",
    fill: "none",
    stroke: "#100F15",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteIcon);
export default __webpack_public_path__ + "static/media/pasteIcon.3d86d81b0d717bc4d9f5c8ce7698d33d.svg";
export { ForwardRef as ReactComponent };